define('viewmodels/RaSocialization/Dashboard',['knockout', 'plugins/router', 'durandal/app', 'services/appsecurity', 'services/navigation', 'durandal/system', 'services/logger', 'services/utils', 'viewmodels/GeneralSettings'],
    function (ko, router, app, appsecurity, navigation, system, logger, utils, ObjGeneralSettings) {

        var SurveyDashboardVM = {
            title: ko.observable("Dashboard"),
            attached: attached,
            activate: activate,
            appsecurity: appsecurity,
            logger: logger,
            utils: utils,
            ObjGeneralSettings: ObjGeneralSettings,
            BUTitle: ko.observable('Business Unit'),
            SurveyTypeDrpDwnList: ko.observableArray(),
            RolesDrpDwnList: ko.observableArray(),   // added for role drop down in dashboard page
            RoleValue: ko.observable(),
            GetSurveyDashboard: GetSurveyDashboard,
            test: ko.observable(),
            Notificationlist: ko.observableArray(),
            NewAssignmentlist: ko.observableArray(),
            WorkInProgresslist: ko.observableArray(),
            CompletedList: ko.observableArray(),
            Completedlist: ko.observableArray(),
            NotificationList: ko.observableArray(),

            AssignedCount: ko.observable(0),
            WorkInProgressCount: ko.observable(0),
            CompletedCount: ko.observable(0),
            NotificationsCount: ko.observable(0),
            ResponseMoveArray: ko.observable(),   // added for navigation to response screen
            surveydropdownevent: surveydropdownevent,
            NewAssignmentTargetRow: ko.observable(),
            WIPClick: WIPClick,
            NewAssignmentClick: NewAssignmentClick,
            RoutedFrom: ko.observable("Dashboard"),
            //variables for export to excel (Total survey)
            ExportSurveyToExcel: ExportSurveyToExcel,
            ImportExcelPopUp: ImportExcelPopUp,
            popUpTitle: ko.observable(),
            addPopUpCss: ko.observable(),
            SurveyProfileId: ko.observable(),
            BusinessUnitId: ko.observable(),
            SurveyType: ko.observable(),
            ImportSurveyType: ko.observable(),
            SurveyTypeShort: ko.observable(),
            UploadExcelDocument: UploadExcelDocument,
            CompltedItemClick: CompltedItemClick
        };
        var GetAllSurveyTypeAjax = {};
        var RaTableObj = false;
        var CompletedTblObj = false;
        var NotificationTblObj = false;

        return SurveyDashboardVM;




        function activate() {
            try {
                SurveyDashboardVM.RoutedFrom("Dashboard");
               
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | activate() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        };

        function attached() {
            try {
                appsecurity.SocializationReadOnly(false);
                SurveyDashboardVM.RoutedFrom("Dashboard");
                //var url = window.location.pathname;
                //var filename = url.substring(url.lastIndexOf('/') + 1);
                //if (filename == "SurveyResponse") {
                //    window.location.pathname = window.location.pathname.replace('SurveyResponsePage', 'SurveyDashBoard')
                //}

                RaTableObj = $('#tblNewAssignment').DataTable({
                    "iDisplayLength": 5,
                    responsive: true,
                    "aoColumnDefs": [{
                        "aTargets": [1],
                        "bSearchable": false
                    }]
                });

                WIPTableObj = $('#tblWorkInProgress').DataTable({
                    "iDisplayLength": 5,
                    responsive: true,
                    "aoColumnDefs": []
                });

                NotificationTblObj = $('#tblNotification').DataTable();
                CompletedTblObj = $('#tblCompleted').DataTable({
                    "iDisplayLength": 5,
                    responsive: true
                });
                $('#divTables').hide();
                    //GetAllUserRole();
                if (SurveyDashboardVM.appsecurity != undefined && SurveyDashboardVM.appsecurity.userInfo() != undefined && SurveyDashboardVM.appsecurity.userInfo().PrimaryRoleId() != undefined) {
                    SurveyDashboardVM.RoleValue(SurveyDashboardVM.appsecurity.userInfo().PrimaryRoleId());
                }

                GetSurveyDashboard();
        

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | attached() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        };


        //--------------------------------------------------------------Event Handling on the Page Starts Here-----------------------------------------------------------------------------------

        function NewAssignmentClick(data, event) {
            try {
                var BuId = data.BuId();
                var BuName = data.BuName();
                var AssignedDate = data.AssignedDate();
                app.showMessage('Do you want to move selected survey to your Work In Progress list?', 'Move Survey', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-exchange text-default' })
                        .then(function (option) {
                            if (option === 'Confirm') {
                                MoveSurveyToWorkInProgress(BuId, BuName,AssignedDate);
                            }
                        });
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | NewAssignmentClick() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }

        
        function CompltedItemClick(data, event) {
            try {
                appsecurity.SocializationReadOnly(false);
                var BuId = data.BuId();
                var BuName = data.BuName();
                var RatId = data.AssessmentId();
                var Status = "";
                var RoleType = "";
                var OVERRIDE_FLAG;
                var APPROVER_FLAG;
                for (var i = 0; i < SurveyDashboardVM.RolesDrpDwnList().length; i++) {
                    if (SurveyDashboardVM.RolesDrpDwnList()[i].RoleId() == $('#RoleDrpDown').val()) {
                        RoleType = SurveyDashboardVM.RolesDrpDwnList()[i].RoleType();
                        OVERRIDE_FLAG = 0;
                        APPROVER_FLAG = 0;
                        break;
                    }
                }
                SurveyDashboardVM.ResponseMoveArray(new ResponseMoveModel({ BusinessUnitId: BuId, BusinessUnitName: BuName, RoleId: $('#RoleDrpDown').val(), RoleName: $("#RoleDrpDown option:selected").text(), RoleType: RoleType, OVERRIDE_FLAG: OVERRIDE_FLAG, APPROVER_FLAG: APPROVER_FLAG, ReadOnly_FLAG: true, RatId: RatId}));
                                                                    // 2 = CRA and 1 = AML/OFAC
                    router.navigate("#RaSocialization/SocializationResponse", true);
                
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | CompltedItemClick() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }

        function WIPClick(data, event) {
            try {
                appsecurity.SocializationReadOnly(false);
                var BuId = data.BuId();
                var BuName = data.BuName();
                var RatId = data.AssessmentId();
                var Status = "";
                var RoleType = "";
                var OVERRIDE_FLAG;
                var APPROVER_FLAG;
                for (var i = 0; i < SurveyDashboardVM.RolesDrpDwnList().length; i++)
                {
                    if(SurveyDashboardVM.RolesDrpDwnList()[i].RoleId() == $('#RoleDrpDown').val() )
                    {
                        RoleType = SurveyDashboardVM.RolesDrpDwnList()[i].RoleType();
                        OVERRIDE_FLAG = SurveyDashboardVM.RolesDrpDwnList()[i].OVERRIDE_FLAG();
                        APPROVER_FLAG = SurveyDashboardVM.RolesDrpDwnList()[i].APPROVER_FLAG();
                        break;
                    }
                }
                SurveyDashboardVM.ResponseMoveArray(new ResponseMoveModel({ BusinessUnitId: BuId, BusinessUnitName: BuName, RoleId: $('#RoleDrpDown').val(), RoleName: $("#RoleDrpDown option:selected").text(), RoleType: RoleType, OVERRIDE_FLAG: OVERRIDE_FLAG, APPROVER_FLAG: APPROVER_FLAG, ReadOnly_FLAG: false, RatId: RatId }));
                                                             // 2 = CRA and 1 = AML/OFAC
                router.navigate("#RaSocialization/SocializationResponse", true);

               
                
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | WIPClick() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }

        function surveydropdownevent(data, event) {
            try {
                if (SurveyDashboardVM.RolesDrpDwnList().length != 0) {
                    if (SurveyDashboardVM.ResponseMoveArray() != undefined && SurveyDashboardVM.ResponseMoveArray().length != 0) {
                        if (SurveyDashboardVM.RolesDrpDwnList()[0].RoleId() != SurveyDashboardVM.ResponseMoveArray().RoleId()) {
                            SurveyDashboardVM.RoleValue(SurveyDashboardVM.ResponseMoveArray().RoleId());
                            document.getElementById('RoleDrpDown').options[document.getElementById('RoleDrpDown').selectedIndex].innerText = SurveyDashboardVM.ResponseMoveArray().RoleName();
                            SurveyDashboardVM.ResponseMoveArray([]);
                        }
                    }
                    if (SurveyDashboardVM.RolesDrpDwnList() != '') {
                        GetSurveyDashboard();
                    }
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | surveydropdownevent() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }

        function GetSurveyDashboard() {
            try {
                $('#divTables').hide();
                $('#loadingImgforDashboard').show();
                GetAllNotification();
                GetAllNewAssignment(SurveyDashboardVM.test()).then(function () {
                    GetAllWorkInProgress(SurveyDashboardVM.test()).then(function () {
                        GetAllCompleted(SurveyDashboardVM.test()).then(function () {
                            $('#loadingImgforDashboard').hide();
                            $('#divDashboard').show();
                            $('#divTables').show();
                        })
                    })
                })

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetSurveyDashboard() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }

        //--------------------------------------------------------------Event Handling on the Page Starts Here-----------------------------------------------------------------------------------

       
        //----------------------------------------------------------------Logic to Populate all 4 Grids on Dashboard Starts Here--------------------------------------------------------------------------------

        // for getting all the New Assignment 
        function GetAllNewAssignment() {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetAllNewAssignment?roleid=" + SurveyDashboardVM.RoleValue(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllNewAssignment() in SurveyDashboard.js'
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null) {
                        SurveyDashboardVM.appsecurity.WriteAccess('true');
                        SurveyDashboardVM.AssignedCount(jsonResult.length);
                        SurveyDashboardVM.NewAssignmentlist([]);
                        RaTableObj.destroy();
                        $('#tblNewAssignment tbody tr').remove();
                        var mappedQuestion = $.map(jsonResult, function (result) {
                            var QuesObj = new GenericModel(result);
                            return QuesObj;
                        })
                        SurveyDashboardVM.NewAssignmentlist(mappedQuestion);
                        RaTableObj = $('#tblNewAssignment').DataTable({
                            "aLengthMenu": [5, 10, 25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false
                            }, {
                                "aTargets": [1],
                                "bSearchable": false
                            }]
                        });
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the New Assignments queue.', 'Error', system.getModuleId(SurveyDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllNewAssignment() in SurveyDashboard.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllNewAssignment() method in SurveyDashBoard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllNewAssignment() method in SurveyDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }


        // for getting all the notification
        function GetAllNotification() {
            try {

                $.ajax({
                    url: "/api/Survey/GetAllNotification",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllNotification() in SurveyDashboard.js'
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null) {
                        SurveyDashboardVM.NotificationsCount(jsonResult.length);
                        SurveyDashboardVM.NotificationList([]);
                        NotificationTblObj.destroy();
                        $('#tblNotification tbody tr').remove();
                        var mappedNotification = $.map(jsonResult, function (result) {
                            var Notificationbj = new GenericModel(result);
                            return Notificationbj;
                        })
                        SurveyDashboardVM.NotificationList(mappedNotification);
                        NotificationTblObj = $('#tblNotification').DataTable();
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Notifications queue.', 'Error', system.getModuleId(SurveyDashboardVM), true);
                    }


                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllNotification() in SurveyDashboard.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllNotification() method in SurveyDashBoard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllNotification() method in SurveyDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }


        // for getting all the work in progress items
        function GetAllWorkInProgress(SurveyType) {
            try {
                return $.ajax({
                    url: "/api/Configuration/GetAllWorkInProgress?roleid=" + SurveyDashboardVM.RoleValue(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | GetAllWorkInProgress() in SurveyDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null) {
                        SurveyDashboardVM.appsecurity.WriteAccess('true');
                        SurveyDashboardVM.WorkInProgressCount(jsonResult.length);
                        SurveyDashboardVM.WorkInProgresslist([]);
                        WIPTableObj = $('#tblWorkInProgress').DataTable();
                        WIPTableObj.destroy();
                        $('#tblWorkInProgress tbody tr').remove();
                        var mappedQuestion = $.map(jsonResult, function (result) {
                            var QuesObj = new GenericModel(result);
                            return QuesObj;
                        })
                        SurveyDashboardVM.WorkInProgresslist(mappedQuestion);
                        WIPTableObj = $('#tblWorkInProgress').DataTable({
                            "aLengthMenu": [5,10,25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false

                            }, {
                                "aTargets": [1],
                                "bSearchable": false
                            }]
                        });
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Work In Progress queue.', 'Error', system.getModuleId(SurveyDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllWorkInProgress() in SurveyDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllWorkInProgress() method in SurveyDashBoard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllWorkInProgress() method in SurveyDashboard.js';
                    logger.logMessage(msg);
                }
            }
        }


        // for getting all the completed items
        function GetAllCompleted(SurveyType) {
            try {

                return $.ajax({
                    url: "/api/Configuration/GetAllCompleted?RoleId=" + SurveyDashboardVM.RoleValue(),
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajax call in GetAllCompleted() in SurveyDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {

                    if (jsonResult != null) {
                        SurveyDashboardVM.appsecurity.WriteAccess('true');
                        SurveyDashboardVM.CompletedCount(jsonResult.length);
                        SurveyDashboardVM.CompletedList([]);
                        CompletedTblObj.destroy();
                        $('#tblCompleted tbody tr').remove();
                        var mappedQuestion = $.map(jsonResult, function (result) {
                            var QuesObj = new GenericModel(result);
                            return QuesObj;
                        })
                        SurveyDashboardVM.CompletedList(mappedQuestion);
                        CompletedTblObj = $('#tblCompleted').DataTable({
                            "aLengthMenu": [5,10,25, 50, 100],
                            responsive: true,
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bSearchable": false
                            }, {
                                "aTargets": [1],
                                "bSearchable": false
                            }]
                        });
                    }
                    else {
                        $('#loadingImgforDashboard').hide();
                        logger.logError('An error occurred while fetching the Completed Assignments queue.', 'Error', system.getModuleId(SurveyDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in GetAllCompleted() in SurveyDashboard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    $('#loadingImgforDashboard').hide();
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllCompleted() method in SurveyDashBoard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllCompleted() method in SurveyDashboard.js';
                    logger.logMessage(msg);
                }
            }

        }

        //----------------------------------------------------------------Logic to Populate all 4 Grids on Dashboard Ends Here--------------------------------------------------------------------------------

        //---------------------------------------------------------------Logic to Move Survey from New Assignment to WIP Starts Here------------------------------------------------------------------

        function MoveSurveyToWorkInProgress( BuID, BName,AssignedDate) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Configuration/MoveSurveyToWorkInProgress?BuId=" + BuID,
                    headers: headers,
                    type: "Post",
                    async: false
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ajax call in MoveSurveyToWorkInProgress() in SurveyDashboard.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult == 1) {
                        GetAllNewAssignment();
                        GetAllWorkInProgress(SurveyDashboardVM.test());
                        logger.logSuccess('Survey has been moved to the Working queue successfully.', 'Success', system.getModuleId(SurveyDashboardVM), true);
                        SurveyDashboardVM.WorkInProgressCount(SurveyDashboardVM.WorkInProgressCount() + 1);
                        SurveyDashboardVM.AssignedCount(SurveyDashboardVM.AssignedCount() - 1);
                    }
                    else if (jsonResult == 0) {
                        logger.logWarning('The Survey that you are trying to move has already been picked by another user.', 'Success', system.getModuleId(SurveyDashboardVM), true)
                        GetAllNewAssignment(SType);
                    }

                    else {
                        logger.logError('An error occurred while moving the Assignment to Work in Progress queue.', 'Error', system.getModuleId(SurveyDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception' + e + 'Source: ajaxSuccess in MoveSurveyToWorkInProgress() in SurveyDashBoard.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                router.navigate("configuration", true);

                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in SurveyDashBoard.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in MoveSurveyToWorkInProgress() method in SurveyDashBoard.js';
                    logger.logMessage(msg);
                }
            }
        }

        //---------------------------------------------------------------Logic to Move Survey from New Assignment to WIP Ends Here------------------------------------------------------------------

        //--------------------------------------------------------------------------Logic for export to excel (Total Survey) Starts Here----------------------------------------------------------------
        function ExportSurveyToExcel(data, event) {
            try {
                if (data.SurveyTypeShort() == "QTDR") {
                    var payLoad = {
                        t: appsecurity.getAuthenticationInfo(), BussinessUnitId: data.BuId(), SurveyID: data.SurveyProfileId(), SurveyType: data.SurveyType(), SurveyName: $('<div/>').html(data.SurveyId()).text()
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelSurvey", payLoad, '_blank');
                }
                else if (data.SurveyTypeShort() == "QLDR") {

                    //url = "/api/FileDownload/ExportExcelQualSurvey?BussinessUnitId=" + data.BuId() + "&SurveyID=" + data.SurveyProfileId() + "&SurveyType=" + data.SurveyType() + "&SurveyName=" + data.SurveyId()
                    var payLoad = {
                        t: appsecurity.getAuthenticationInfo(), BussinessUnitId: data.BuId(), SurveyID: data.SurveyProfileId(), SurveyType: data.SurveyType(), SurveyName: $('<div/>').html(data.SurveyId()).text()
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/ExportExcelQualSurvey", payLoad, '_blank');
                }
                else if (data.SurveyTypeShort() == "CDR") {

                    var payLoad = {
                        t: appsecurity.getAuthenticationInfo(), BussinessUnitId: data.BuId(), SurveyID: data.SurveyProfileId(), SurveyType: data.SurveyType(), SurveyName: $('<div/>').html(data.SurveyId()).text()
                    };
                    utils.postAndRedirect(rootPath + "/FileDownload/GetControlsExcel", payLoad, '_blank');
                }
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | ExportSurveyToExcel() in SurveyDashboard.js';
                logger.logMessage(msg);
            }
        }
        //--------------------------------------------------------------------------Logic for export from excel (Total Survey) ends Here----------------------------------------------------------------

        //--------------------------------------------------------------------------Logic for Import to excel starts here-------------------------------------------------------------
        function ImportExcelPopUp(data, event) {
            try {
                SurveyDashboardVM.SurveyProfileId(data.SurveyProfileId());
                SurveyDashboardVM.BusinessUnitId(data.BuId());
                SurveyDashboardVM.SurveyType(data.SurveyType());
                SurveyDashboardVM.SurveyTypeShort(data.SurveyTypeShort());
                SurveyDashboardVM.ImportSurveyType(data.SurveyTypeShort());
                SurveyDashboardVM.popUpTitle("Import Excel");
                document.getElementById('valfactorerror').innerHTML = "";
                $('#valfactorerror').hide();
                SurveyDashboardVM.addPopUpCss(true);
                $('#Exportexcel').modal('show');
                $('#modalContent').css({
                    'margin-top': '25%'
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source:ImportExcelPopUp() method in SurveyDashBoard.js';
                logger.logMessage(msg);
            }
        }
        function UploadExcelDocument(data, event) {
            try {
                var FileList = document.getElementById('FileUploader').files;
                if (FileList.length > 0) {
                    var FileName = document.getElementById('FileUploader').files[0].name;
                    if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                        ) {
                        if (FileList[0].size <= 1073741824) {

                            document.getElementById('valfactorerror').innerHTML = "";

                            var FormDataObj = new FormData();
                            FormDataObj.append("File1", FileList[0]);
                            var request = new XMLHttpRequest();

                            request.onreadystatechange = function () {
                                if (request.readyState == 1) {
                                    document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                    $('#valfactorerror').show();
                                }
                                else if (request.readyState == 4) {
                                    if (request.status == 200) {
                                        if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                            if (request.responseText == "2") {
                                                document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                                logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(SurveyDashboardVM), true);
                                                $('#valfactorerror').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = null;
                                                // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                            else if (request.responseText == "-1") {

                                                document.getElementById('valfactorerror').innerHTML = "Error in file upload";
                                                logger.logWarning('Excel format mismatch. Please check and try again.', 'Warning', system.getModuleId(SurveyDashboardVM), true);
                                                $('#valfactorerror').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = null;
                                                // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();

                                            }
                                            else {
                                                document.getElementById('valfactorerror').innerHTML = "The file has been uploaded successfully.";
                                                logger.logSuccess('Responses Uploaded Successfully ', 'Success', system.getModuleId(SurveyDashboardVM), true);
                                                $('#valfactorerror').show();
                                                var DocName = document.getElementById('FileUploader').files[0].name;
                                                document.getElementById('FileUploader').value = null;
                                                // SetComments(data.QuestionId(), "RD", "", DocName, JSON.parse(request.response), SrViewModel.UploadComment());
                                                $('#Exportexcel').modal('hide');
                                                $('body').removeClass('modal-open');
                                                $('.modal-backdrop').remove();
                                            }
                                        }
                                        else {


                                            document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                            logger.logError('Some Error Occured while Uploading Report.', 'Error', system.getModuleId(SurveyDashboardVM), true);
                                            $('#valfactorerror').show();
                                            document.getElementById('FileUploader').value = null;
                                            $('#Exportexcel').modal('hide');
                                            $('body').removeClass('modal-open');
                                            $('.modal-backdrop').remove();

                                        }
                                    }
                                    else
                                        ajaxFail(request, "");
                                }
                            };
                            request.upload.addEventListener('progress', function (event) {
                               
                                document.getElementById('valfactorerror').innerHTML = "Uploading File...";

                            });
                            request.withCredentials = true;
                            if (SurveyDashboardVM.SurveyTypeShort() == "QTDR") {


                                request.open('POST', "/api/Survey/ImportExcelQuanSurvey?SurveyProfileId=" + SurveyDashboardVM.SurveyProfileId() + "&BusinessUnitId=" + SurveyDashboardVM.BusinessUnitId() + "&SurveyType=" + SurveyDashboardVM.SurveyTypeShort() + "&RoleId=" + SurveyDashboardVM.RoleValue());
                            }
                            else if (SurveyDashboardVM.SurveyTypeShort() == "QLDR") {



                                request.open('POST', "/api/Survey/ImportExcelQualSurvey?SurveyProfileId=" + SurveyDashboardVM.SurveyProfileId() + "&BusinessUnitId=" + SurveyDashboardVM.BusinessUnitId() + "&SurveyType=" + SurveyDashboardVM.SurveyTypeShort() + "&RoleId=" + SurveyDashboardVM.RoleValue());
                            }
                            else if (SurveyDashboardVM.SurveyTypeShort() == "CDR" || SurveyDashboardVM.SurveyTypeShort() == "CDR") {



                                request.open('POST', "/api/Survey/ImportExcelControlsSurvey?SurveyProfileId=" + SurveyDashboardVM.SurveyProfileId() + "&BusinessUnitId=" + SurveyDashboardVM.BusinessUnitId() + "&SurveyType=" + SurveyDashboardVM.SurveyTypeShort() + "&RoleId=" + SurveyDashboardVM.RoleValue());
                            }
                            var csrfToken = $("input[name='__RequestVerificationToken']").val();
                            var headers = appsecurity.getSecurityHeaders();
                            headers.__RequestVerificationToken = csrfToken;
                            request.setRequestHeader('Authorization', headers.Authorization);
                            request.setRequestHeader('RT', headers.RT);
                            request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                            request.send(FormDataObj);

                        }
                        else
                            document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed " + (SrViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                    }
                    else
                        document.getElementById('valfactorerror').innerHTML = "Please Select Valid File to Upload";
                }

                else
                    document.getElementById('valfactorerror').innerHTML = "Please Select a File to Upload";

                function ajaxFail(error, status) {

                    try {
                        if (error.status == 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    router.navigate("survey/SurveyDashBoard", true);

                            })
                        }
                        else {
                            var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                            logger.logMessage(msg);
                        }
                    } catch (e) {
                        var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                };
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadExcelDocument() method in SurveyDashBoard.js';
                logger.logMessage(msg);
            }
        }
        //--------------------------------------------------------------------------Logic for Import to excel ende here---------------------------------------------------------------
        //----------------------------------------------------------------------Model Definition Starts Here----------------------------------------------------------------------------------

       
        function GenericModel(item) {
            try {
                var self = this;
                self.SuId = ko.observable(item.SuId);
                self.NotificationDate = ko.observable(item.NotificationDate);
                self.NotificationMessage = ko.observable(item.NotificationMessage);
                self.NotificationDate = ko.observable(item.NotificationDate);
                self.NotificationPriority = ko.observable(item.NotificationPriority);
                self.NotificationSender = ko.observable(item.NotificationSender);
                self.SurveyId = ko.observable($('<div/>').html(item.SurveyId).text());
                self.BuId = ko.observable(item.BuId);
                self.BuName = ko.observable($('<div/>').html(item.BuName).text());
                self.SurveyType = ko.observable($('<div/>').html(item.SurveyType).text());
                self.SurveyTypeShort = ko.observable($('<div/>').html(item.SurveyTypeShort).text());
                self.SurveyProfileId = ko.observable($('<div/>').html(item.SurveyProfileId).text());
                self.AssignedDate = ko.observable($('<div/>').html(item.AssignedDate).text());
                self.IsEditableFlag = ko.observable(item.IsEditableFlag);
                self.AssignedUser = ko.observable(item.AssignedUser);
                self.SurveyStatus = ko.observable(item.SurveyStatus);
                self.AssessmentId = ko.observable(item.AssessmentId);
                self.RiskConfigType = ko.observable(item.RiskConfigType);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: GenericModel() in SurveyDashBoard.js';
                logger.logMessage(msg);
            }
        }

        

        function ResponseMoveModel(item) {
            try {
                var self = this;
                self.SurveyProfileId = ko.observable(item.SurveyProfileId);
                self.SurveyTypeId = ko.observable(item.SurveyTypeId);
                self.PageHeaderName = ko.observable(item.PageHeaderName);
                self.BusinessUnitId = ko.observable(item.BusinessUnitId);
                self.BusinessUnitName = ko.observable(item.BusinessUnitName);
                self.SurveyType = ko.observable(item.SurveyType);
                self.SurveyId = ko.observable(item.SurveyId);
                self.RoleId = ko.observable(item.RoleId);
                self.RoleName = ko.observable(item.RoleName);
                self.RoleType = ko.observable(item.RoleType);
                self.SurveyStatus = ko.observable(item.SurveyStatus);
                self.OVERRIDE_FLAG= ko.observable(item.OVERRIDE_FLAG); 
                self.APPROVER_FLAG = ko.observable(item.APPROVER_FLAG);
                self.ReadOnly_FLAG = ko.observable(item.ReadOnly_FLAG);
                self.RatId = ko.observable(item.RatId);
                
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source: ResponseMoveModel() in SurveyDashBoard.js';
                logger.logMessage(msg);
            }
        }


        //----------------------------------------------------------------------Model Definition Ends Here----------------------------------------------------------------------------------

    });
